import { Link } from 'react-router-dom';
import { featuredComics } from '@/mocks/comics';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Epic%20cosmic%20space%20scene%20with%20colorful%20nebula%20clouds%2C%20distant%20stars%2C%20spiral%20galaxy%2C%20mysterious%20alien%20planet%20silhouette%2C%20dramatic%20warm%20orange%20and%20golden%20light%20rays%2C%20dark%20deep%20space%20background%2C%20cinematic%20composition%2C%20no%20text%2C%20abstract%20ethereal%20vibe%2C%20clean%20minimal%20cosmic%20art&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="星球漫画 - 星际科幻漫画宇宙漫画大全"
        title="星球漫画 - 星际科幻漫画宇宙漫画大全"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      <div className="absolute inset-0 flex items-center">
        <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
          <div className="max-w-2xl">
            <h1 className="font-heading text-3xl md:text-5xl font-bold text-background-50 leading-tight mb-4">
              探索星际，<br />畅游<strong>科幻漫画</strong>宇宙
            </h1>
            <p className="text-sm md:text-base text-background-200/90 leading-relaxed mb-8 max-w-lg">
              星球漫画汇集海量<strong>星际漫画</strong>、<strong>宇宙漫画</strong>与<strong>太空冒险漫画</strong>，
              提供下拉式阅读体验，让您沉浸在浩瀚星河之中。每日更新，免费畅读。
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <Link
                to="/category/xingjimaoxian-manhua"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-md font-medium text-sm transition-colors whitespace-nowrap cursor-pointer"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-rocket-line"></i>
                </div>
                开始阅读
              </Link>
              <Link
                to="/category/kehuan-manhua"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-background-50/10 hover:bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-md font-medium text-sm transition-colors whitespace-nowrap cursor-pointer"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-cpu-line"></i>
                </div>
                科幻漫画精选
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
        <span className="text-xs text-background-50/60">向下滚动探索</span>
        <div className="w-4 h-4 flex items-center justify-center animate-bounce">
          <i className="ri-arrow-down-line text-background-50/60"></i>
        </div>
      </div>
    </section>
  );
}